import { CHANGE_LANGUAGE_SUCCESS } from "../types";

const initialState = {
  languages: [
    { locale: "en", name: "English", code: "ENG" },
    { locale: "es", name: "Spanish Español", code: "ESP" },
    { locale: "hi", name: "Hindi हिंदी", code: "HIN" },
    { locale: "pt", name: "Portuguese Português", code: "POR" },
    { locale: "de", name: "German Deutsche", code: "GER" },
    { locale: "bn", name: "Bengali বাংলা", code: "BEN" },
  ],
  selectedLanguage: "en",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE_SUCCESS:
      return {
        ...state,
        selectedLanguage: state.languages.find(
          ({ locale }) => locale === action.payload
        ).locale,
      };

    default:
      return state;
  }
};
